var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "planswitchhistory-page page-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "planswitch_headercontainer d-flex align-items-end justify-content-between flex-wrap gap-2"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _vm._m(0)], 1)]), _c('div', {
    staticClass: "row plan-switch-card"
  }, [_c('div', {
    staticClass: "planswitchhistory-filters"
  }, [_c('div', {
    staticClass: "row align-items-end"
  }, [_c('div', {
    staticClass: "col-md-4 mb-3 "
  }, [_c('div', {
    staticClass: "filter-input-wrap w-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.member_name,
      expression: "filters.member_name"
    }],
    staticClass: "filter-input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Member Name"
    },
    domProps: {
      "value": _vm.filters.member_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "member_name", $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6"
    }
  })])])])]), _c('div', {
    staticClass: "col-md-4 mb-3 "
  }, [_c('div', {
    staticClass: "filter-input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.old_plan,
      expression: "filters.old_plan"
    }],
    staticClass: "filter-input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Old Plan"
    },
    domProps: {
      "value": _vm.filters.old_plan
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "old_plan", $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6"
    }
  })])])])]), _c('div', {
    staticClass: "col-md-4 mb-3 "
  }, [_c('div', {
    staticClass: "filter-input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.new_plan,
      expression: "filters.new_plan"
    }],
    staticClass: "filter-input",
    attrs: {
      "type": "text",
      "placeholder": "Enter New Plan"
    },
    domProps: {
      "value": _vm.filters.new_plan
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "new_plan", $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6"
    }
  })])])])]), _c('div', {
    staticClass: "col-md-4 mb-3 mb-md-0 "
  }, [_c('div', {
    staticClass: "date-range-wrapper"
  }, [_c('div', {
    staticClass: "fw-semibold"
  }, [_vm._v("Date:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.date,
      expression: "filters.date"
    }],
    staticClass: "date-input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.filters.date
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "date", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "d-flex gap-2"
  }, [_c('button', {
    staticClass: "search-btn univ-btn py-2 px-3 d-flex align-items-center gap-1 m-0 w-auto",
    on: {
      "click": _vm.getPlanSwitchLogs
    }
  }, [_c('span', {
    staticClass: "icon-wrap d-flex align-items-center justify-content-center"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6"
    }
  })])]), _vm._v(" Search ")]), _c('button', {
    staticClass: "clear-btn d-flex align-items-center gap-1",
    on: {
      "click": _vm.clearFilters
    }
  }, [_c('span', {
    staticClass: "icon-wrap d-flex align-items-center justify-content-center"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z"
    }
  })])]), _vm._v(" Clear ")])])])])]), _c('div', {
    staticClass: "top-pagination p-0"
  }, [_c('pagination', {
    attrs: {
      "rows": _vm.rows,
      "filters": _vm.filters
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      }
    }
  })], 1), _c('div', {
    staticClass: "table-responsive p-0"
  }, [_c('table', {
    staticClass: "table planswitchhistory-table"
  }, [_vm._m(1), _c('tbody', [_vm._l(_vm.planSwitches, function (item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.policy_id))]), _c('td', [_c('div', {
      staticClass: "fw-semibold"
    }, [_vm._v(_vm._s(item.member_name))])]), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.created_at)))]), _c('td', [_vm._v(_vm._s(item.old_plan_name))]), _c('td', [_vm._v(_vm._s(item.new_plan_name))]), _c('td', [_c('div', {
      staticClass: "d-flex align-items-center gap-2"
    }, [_c('div', {
      staticClass: "avatar-circle d-flex align-items-center justify-content-center"
    }, [_vm._v(" " + _vm._s(_vm.getInitials(item.requested_by)) + " ")]), _c('div', [_c('div', {
      staticClass: "fw-semibold"
    }, [_vm._v(_vm._s(item.requested_by))])])])]), _c('td', [_vm._v(_vm._s(item.origin))]), _c('td', [_c('button', {
      staticClass: "view-link",
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.openViewModal(item);
        }
      }
    }, [_vm._v("View")])])]);
  }), _vm.planSwitches.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No plan switch history found")])]) : _vm._e()], 2)])]), _c('pagination', {
    attrs: {
      "rows": _vm.rows,
      "filters": _vm.filters
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      }
    }
  })], 1)]), _c('PlanSwitchHistoryModal', {
    attrs: {
      "isOpen": _vm.showPlanSwitchHistoryModal,
      "row": _vm.row
    },
    on: {
      "close": function close($event) {
        _vm.showPlanSwitchHistoryModal = false;
      }
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Plan Switch History")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("System ID")]), _c('th', [_vm._v("Member Name")]), _c('th', [_vm._v("Date & Time")]), _c('th', [_vm._v("Old Plan")]), _c('th', [_vm._v("New Plan")]), _c('th', [_vm._v("Performed by")]), _c('th', [_vm._v("Requested From")]), _c('th', [_vm._v("Details")])])]);
}]

export { render, staticRenderFns }